import { h, Component } from 'preact'
import PostAPI from '../api/PostAPI'
import ErrorMessage from '../components/ErrorMessage'
import Loader from '../components/Loader'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class StyleFilter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      posts: [],
      currentTerms: {
        product_model: this.props.model,
        product_style: '',
      },
      terms: [],
      error: false,
      isLoading: false
    }

    this.handleTerm = this.handleTerm.bind(this)
    this.fillTerms = this.fillTerms.bind(this)
  }

  componentDidMount() {
    this.fetchPosts()
  }

  fetchPosts() {
    this.setState({ isLoading: true })

    PostAPI.all(this.state)
    .then(response => response.json())
    .then(data => {
 
      this.setState( () => {
        return {
          posts: [...this.state.posts, ...data],
          isLoading: false
        }
      }, this.fillTerms ) 
    
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  fillTerms() {
    let allTerms = []

    // Get all terms in all posts (= with duplicates) as flat array
    this.state.posts.map((post) => {
      let termsArray = post.product_style_objects

      ;[...termsArray].forEach(term => {
        allTerms.push( term )
      })
    })

    // Filter out duplicates
    const uniqueTerms = allTerms.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj['term_id']).indexOf(obj['term_id']) === pos;
    })

    this.setState({
      terms: uniqueTerms
    })
  }

  handleTerm(e) {
    this.props.onSelectTerm(e.target.value, 'product_style')
  }

  generateButtons() {
    let buttons = []

    // Default button
    buttons.push( this.generateDefaultButton() )

    // Make a button for each term
    this.state.terms.map((term) => {

      // Skip term if it has no posts
      if ( term.count === 0 ) return false

      // Set current class
      let buttonClass = 'c-product-filter__button'
      if ( this.props.currentTerm == term.term_id ) {
        buttonClass = 'c-product-filter__button active'
      }

      // Push to array
      return buttons.push(
        <button
          className={buttonClass}
          value={term.term_id}
          key={term.term_id}
          onClick={this.handleTerm}
          dangerouslySetInnerHTML={{ __html: term.name }}
          disabled={this.props.postsLoading}
        />
      )
    })

    return buttons
  }

  generateDefaultButton() {
    // Set current class
    let defaultClass = 'c-product-filter__button'
    if ( this.props.currentTerm == '' ) {
      defaultClass = 'c-product-filter__button active'
    }

    return (
      <button 
        className={defaultClass} 
        value="" 
        onClick={this.handleTerm} 
        dangerouslySetInnerHTML={{ __html: this.props.defaultOption }}
        disabled={this.props.postsLoading}
      />
    )
  }

  render() {
    let {error, isLoading} = this.state

    if (error) {
      return <ErrorMessage type="filter-error" />
    }

    if (isLoading) {
      return <Loader />
    }

    return (
      <div className="c-product-filter">

        <h6
          dangerouslySetInnerHTML={{ __html: this.props.title }}
          className="c-product-filter__title" 
        />

        { this.generateButtons() }

      </div>
    )
  }
}

export default StyleFilter



// WEBPACK FOOTER //
// ./src/js/products/containers/StyleFilter.js